import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import App from "@/App";

// Apply persisted/default theme as early as possible so every route (incl. /services)
// reflects the user's choice without depending on the Header component being mounted.
try {
  const saved = localStorage.getItem("do_theme") || "light";
  if (saved === "light") document.documentElement.setAttribute("data-theme", "light");
  else document.documentElement.removeAttribute("data-theme");
} catch (_) { /* ignore */ }

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
